import axios from 'axios'
import get from 'lodash/get'
import { responseHandler, apiErrorHandler } from '../actions/handlers.action'
import {
  getMasterDataAction,
  getShipsDataAction,
  getVipIconAction
} from './../actions/masterdata.action'
import { queryResolver } from '../helpers/gqlUtil'
import {
  GET_MASTER_DATA_QUERY,
  GET_SHIPS_QUERY
} from '../graphql/queries/dashboardQueries'
import { masterDataMapper, shipMapper } from '../helpers/mapper'
import { paginationValue } from '../constants'

export const postMasterData = (body = {}) => (dispatch, getState) => {
  const state = getState()
  body.isShipSide = !get(state, 'isShore', false)
  const shipCode = get(state, 'ship', '')
  const pageInfo = {
    page: 1,
    size: paginationValue.allItemsPageSize
  }
  return queryResolver({
    query: GET_MASTER_DATA_QUERY,
    variables: {
      filter: {
        shipCode,
        onlyAlertDepartments: true
      },
      pageFilter: pageInfo,
      shipCode,
      portsPageFilter2: pageInfo,
      visaTypePageFilter: pageInfo,
      statePageFilter: pageInfo,
      shipByCodeShipCode2: shipCode,
      shipTimeByCodeShipCode2: shipCode,
      searchReferenceDataFilter2: {
        referenceDataTypes: ['RCR', 'VBT']
      },
      searchReferenceDataPageFilter2: pageInfo,
      pageSort: {
        direction: 'ASC',
        field: 'code'
      },
      voyagesWithPaginationFilter2: { shipCodes: [shipCode] },
      voyagesWithPaginationPageFilter2: pageInfo,
      gangwayAlertCodesPageFilter2: pageInfo,
      onlyCheckedIn: !get(state, 'isShore', false)
    }
  })
    .then(response => {
      const mappedMasterdata = masterDataMapper(get(response, 'data', ''))
      const mappedResponse = {
        settings: get(state, 'settings', {}),
        isShore: get(state, 'isShore', false),
        data: mappedMasterdata
      }
      responseHandler(dispatch, mappedResponse, getMasterDataAction)
      return mappedResponse
    })
    .catch(error => {
      apiErrorHandler(dispatch, error)
    })
}

export const getShipsData = () => dispatch => {
  return queryResolver({
    query: GET_SHIPS_QUERY
  })
    .then(response => {
      responseHandler(
        dispatch,
        shipMapper(get(response, 'data.ships', [])),
        getShipsDataAction
      )
      return response
    })
    .catch(error => {
      apiErrorHandler(dispatch, error)
    })
}

export const getSailorVipIcons = (body = {}) => (dispatch, getState) => {
  const state = getState()
  return axios
    .post(get(state, 'startup.sailorVipIconURL'), body)
    .then(response => {
      responseHandler(dispatch, response, getVipIconAction)
      return response
    })
    .catch(error => {
      apiErrorHandler(dispatch, error)
    })
}
